import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../../components/card/card.jsx";
import Degradation from "./chart";
import { useParams } from "react-router-dom";
import { formatNumber } from "../../../../utils/helper";
function MachineList({ recalculateRandom, allData, referenceLines }) {
  const [rul, setRul] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [rul2, setRul2] = useState(0);
  const [totalCost2, setTotalCost2] = useState(0);
  useEffect(() => {
    const dataF = allData.filter((item) => item.Ref === "F");
    // will summ all the data from begining until F

    // RUL mean year from dataF minus current year
    if (dataF.length) {
      //get all allData before year of dataF[0].Year
      const dataBefore = allData.filter(
        (item) => parseInt(item.Year) <= parseInt(dataF[0].Year)
      );
      let sum = 0;
      dataBefore.map((i) => {
        sum += i["Total_Cost"];
      });
      const currentYear = new Date().getFullYear();
      if (dataF.length === 1) {
        const year = parseInt(dataF[0].Year);
        const totalYear = year - currentYear;
        setRul(totalYear);
        setTotalCost(sum);
        setRul2(0);
        setTotalCost2(0);
      }
      if (dataF.length === 2) {
        const year = parseInt(dataF[1].Year);
        const totalYear = year - currentYear;
        setRul2(totalYear);
        setTotalCost2(dataF[1]["Cumulative LCC"]);
      }
    }
  }, [allData]);
  let { assetId } = useParams();
  return (
    <Card className="bg-blue-900 border-theme  mb-3">
      <CardBody>
        <div class="row">
          <div class="col-sm-12">
            <div style={{ padding: "10px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontSize: 13,
                  marginBottom: "10px",
                  marginTop: "10px",
                }}
              >
                <div style={{ display: "flex", marginRight: "5px" }}>
                  <div
                    style={{
                      width: "15px",
                      borderBottom: "2px solid #03408a",
                      height: "9px",
                      marginRight: "5px",
                    }}
                  >
                    {" "}
                  </div>
                  <div>Actual</div>
                </div>
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      width: "15px",
                      borderBottom: "2px dashed #705138",
                      height: "9px",
                      marginRight: "5px",
                    }}
                  >
                    {" "}
                  </div>
                  <div>Forecast</div>
                </div>
              </div>
              <Degradation
                referenceLines={referenceLines}
                assetId={assetId}
                allData={allData}
                calculateValue={recalculateRandom}
              />
            </div>
          </div>
          <div class="col-sm-12">
            <Card>
              <CardBody>
                Projected RUL: <b>{rul} Years</b>
                <br />
                Total Strategy Cost: <b>${formatNumber(totalCost)}</b>
                {rul2 ? (
                  <div>
                    <br />
                    RUL2: <b>{rul2} Years</b>
                    <br />
                    Total Strategy Cost: <b>${formatNumber(totalCost2)}</b>
                  </div>
                ) : (
                  ""
                )}
              </CardBody>
            </Card>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default MachineList;
